export default __webpack_public_path__ + "static/media/teleph.75a314dc.svg";